module.exports = __webpack_public_path__ + "img/sneke.0dd57282.png";